import {  Modal, Step, StepLabel, Stepper, TextField } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../../AuthContext/AuthContext";
import { loader } from "../../Func_genericas/loader";
import { cores, mensagem_tem_a_certeza_de_apagar_alteracoes, operacao_erro, operacao_sucesso } from "../../Func_genericas/valores_estaticos";
import { CustomTextField } from "../../Styles/theme/customThemeprovider";
import { get, post, put } from "../../Services/tokenConfig";
import { func_print } from "../../Func_genericas/func_print";
import ConfirmDialog from "../../Components/CustomDialog/customdialog";
import { IPlanoERPSchema } from "../../Interfaces/financeiro/financeiro";
import { ICaderno } from "../../Interfaces/cadernos/caderno1";
import { IPage2 } from "../../Interfaces/cadernos/caderno2";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

interface I_aux {
    lista: IPlanoERPSchema[],
    flag_open_modal: boolean,
    set_flag_open_modal: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_ver_mais: boolean,
    set_flag_open_modal_ver_mais: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_edit: boolean,
    set_flag_open_modal_edit: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_add: boolean,
    set_flag_open_modal_add: React.Dispatch<React.SetStateAction<boolean>>,
    setMessage: React.Dispatch<React.SetStateAction<string>>,
    setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>,
    setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>,
    set_lista: React.Dispatch<React.SetStateAction<IPlanoERPSchema[]>>,
    set_obj_new: React.Dispatch<React.SetStateAction<IPlanoERPSchema | undefined>>,
    obj_new: IPlanoERPSchema | undefined,

}

export const Modaladdfinanceiro: React.FC<I_aux> = ({
    lista,
    flag_open_modal,
    set_flag_open_modal,
    flag_open_modal_ver_mais,
    set_flag_open_modal_ver_mais,
    flag_open_modal_edit,
    set_flag_open_modal_edit,
    flag_open_modal_add,
    set_flag_open_modal_add,
    setMessage,
    setOpenSnackSuccess,
    setOpenSnackError,
    set_lista,
    set_obj_new,
    obj_new,
}) => {
    const auth = useContext(AuthContext);
    const location = useLocation();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [passo_atual, set_passo_atual] = useState<number>(0);

    const steps = [
        'Selecionar Caderno do Plano ERP',
        'Selecionar Áreas de Compromisso do Plano ERP',
        'Configurar Campos do Plano ERP'
    ];

    const [hover, setHover] = useState({ flag: false, id_rosto: 0 });
    const [hover1, setHover1] = useState<any[]>([{ flag: false, id_cara: 0 }]);

    const [lista_cadernos_ativos, set_lista_cadernos_ativos] = useState<ICaderno[]>([]);
    const [lista_caraterizacao, set_lista_caraterizacao] = useState<IPage2[]>([]);

    const [campo_obrigatorio_nome, set_campo_obrigatorio_nome] = useState<boolean>(false);
    const [campo_invalido_ano, set_campo_invalido_ano] = useState<boolean>(false);
    const [error_orcamento_total, set_error_orcamento_total] = useState<boolean>(false);
    const [error_alerta_percentagem, set_error_alerta_percentagem] = useState<boolean>(false);

    const [flag_editado, set_flag_editado] = useState<boolean>(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = useState<boolean>(false);

    const get_info_by_id_rosto = async () => {
        try {
            setIsLoading(true);
            let res_cadernos_ativos = await get(auth.token.cookie_token, `/get_cadernos_list_ativos/${auth.user?.id_org}`);

            if (res_cadernos_ativos.status === 200) {
                set_lista_cadernos_ativos(res_cadernos_ativos.data.result);
            }
            setIsLoading(false);

        } catch (error) {
            func_print("get_info_by_id_rosto", error, true);
            setIsLoading(false);
        }
    }

    const get_info_by_id_cara = async () => {
        try {
            setIsLoading(true);
            let res = await get(auth.token.cookie_token, `/get_caraterizacao_id_rosto/${obj_new?.id_rosto}`);

            if (res.status === 200) {
                set_lista_caraterizacao(res.data.result);
            }
            setIsLoading(false);

        } catch (error) {
            func_print("get_info_by_id_cara", error, true);
            setIsLoading(false);
        }
    }


    useEffect(() => {
        (async () => {
            await get_info_by_id_rosto();
        })();
    }, []);


    const handler_add = async () => {

        if (obj_new?.nome === undefined || obj_new?.nome === '') {
            set_campo_obrigatorio_nome(true)
        } else if (obj_new.ano === undefined || obj_new.ano === null) {
            set_campo_invalido_ano(true)

        } else {

            try {
                setIsLoading(true);
                let res = await post(auth.token.cookie_token, 'api/plano-erp/new', {
                    payload: {
                        nome: obj_new?.nome === undefined ? '' : obj_new?.nome,
                        ano: obj_new?.ano === undefined ? undefined : obj_new?.ano,
                        descricao: obj_new?.descricao === undefined ? '' : obj_new?.descricao,
                        cultura: obj_new?.cultura === undefined ? '' : obj_new?.cultura,
                        estado: obj_new?.estado === undefined ? '' : obj_new?.estado,
                        orcamento_total: obj_new?.orcamento_total === undefined ? 0 : obj_new?.orcamento_total?.toString().replace(",", "."),
                        alerta_percentagem: obj_new?.alerta_percentagem === undefined ? 0 : obj_new?.alerta_percentagem?.toString().replace(",", "."),
                        tipo_entidade: obj_new?.tipo_entidade === undefined ? '' : obj_new?.tipo_entidade,
                        id_cara: obj_new?.id_cara === undefined ? 0 : obj_new?.id_cara,
                        id_rosto: obj_new?.id_rosto === undefined ? 0 : obj_new?.id_rosto,
                        id_agri: location.state,

                    }
                });
                if (lista.length === 0) {
                    set_lista([res.data.result])

                } else {
                    set_lista((old: any) => [...old, res.data.result])

                }
                setMessage(operacao_sucesso)
                setOpenSnackSuccess(true);
                setIsLoading(false);
                func_reset_all()

            } catch (error) {
                func_print("handler_add", error, true);
                setMessage(operacao_erro)
                setOpenSnackError(true);
                setIsLoading(false);
            }
        }

    }
    const handler_edit = async () => {

        if (obj_new?.nome === undefined || obj_new?.nome === '') {
            set_campo_obrigatorio_nome(true)
        } else if (obj_new?.ano === null || obj_new.ano === undefined) {
            set_campo_invalido_ano(true)

        } else {


            try {
                setIsLoading(true);
                let res = await put(auth.token.cookie_token, 'api/plano-erp/' + obj_new.id_plano, {
                    payload: {
                        id_plano: obj_new?.id_plano === undefined ? 0 : obj_new?.id_plano,
                        nome: obj_new?.nome === undefined ? '' : obj_new?.nome,
                        descricao: obj_new?.descricao === undefined ? '' : obj_new?.descricao,
                        cultura: obj_new?.cultura === undefined ? '' : obj_new?.cultura,
                        estado: obj_new?.estado === undefined ? '' : obj_new?.estado,
                        orcamento_total: obj_new?.orcamento_total === undefined ? 0 : obj_new?.orcamento_total?.toString().replace(",", "."),
                        alerta_percentagem: obj_new?.alerta_percentagem === undefined ? 0 : obj_new?.alerta_percentagem?.toString().replace(",", "."),
                        tipo_entidade: obj_new?.tipo_entidade === undefined ? '' : obj_new?.tipo_entidade,
                        id_cara: obj_new?.id_cara === undefined ? 0 : obj_new?.id_cara,
                        id_rosto: obj_new?.id_rosto === undefined ? 0 : obj_new?.id_rosto,
                        id_agri: location.state,

                    }
                });

                let aux_list = lista.map((el) => {
                    if (el.id_plano === obj_new.id_plano) {
                        return res.data.result
                    } else {
                        return el
                    }
                })

                set_lista(aux_list)


                setMessage(operacao_sucesso)
                setOpenSnackSuccess(true);
                setIsLoading(false);
                func_reset_all()

            } catch (error) {
                func_print("handler_edit", error, true);
                setMessage(operacao_erro)
                setOpenSnackError(true);
                setIsLoading(false);
            }
        }

    }

    const onInputChange = (e: any) => {
        const { name, value } = e.target;
        set_flag_editado(true)


        if (name === 'orcamento_total') {
            if (!/^(\d+([.,]\d+)?)$/.test(value)) {
                set_error_orcamento_total(true)
            } else {
                set_error_orcamento_total(false)
            }
            set_obj_new((prev: any) => ({
                ...prev,
                [name]: value,
            }));
        } else if (name === 'alerta_percentagem') {
            if (!/^(\d+([.,]\d+)?)$/.test(value)) {
                set_error_alerta_percentagem(true)
            } else {
                set_error_alerta_percentagem(false)
            }
            set_obj_new((prev: any) => ({
                ...prev,
                [name]: value,
            }));
        } else {
            set_obj_new((prev: any) => ({
                ...prev,
                [name]: value,
            }));
        }
    }


    const func_reset_all = () => {
        set_obj_new(undefined);
        set_flag_open_modal_edit(false);
        set_flag_open_modal(false);
        set_campo_obrigatorio_nome(false);
        set_flag_open_modal(false);
        set_flag_editado(false)
        set_flag_open_modal_ver_mais(false);
        set_flag_open_modal_add(false);
        set_campo_invalido_ano(false);
        set_error_alerta_percentagem(false);
        set_error_orcamento_total(false);

    }
    const handleCloseDialog = () => {
        func_reset_all()
        set_flag_editado(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    };

    return (<Modal
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        open={flag_open_modal}
    >
        <div className="flex flex-col bg-white w-[70%] max-h-[80%] rounded-xl overflow-hidden">
            <div className="flex items-center justify-between w-full p-4 border-b border-gray-100">
                <h2 className="text-xl font-semibold text-gray-800 m-0 pl-2">
                    {
                        flag_open_modal_edit === true ? 'Editar Plano ERP' :
                            flag_open_modal_ver_mais === true ? 'Detalhes do Plano ERP' :
                                'Adicionar Plano ERP'
                    }
                </h2>
                <button
                    type="button"
                    onClick={() => {
                        if (flag_editado) {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                        } else {
                            set_flag_open_modal(false)
                            set_flag_open_modal_edit(false)
                            set_flag_open_modal_ver_mais(false)
                        }
                    }}
                    className="p-1 text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
                >
                    <CloseIcon sx={{ fontSize: 24 }} />
                </button>
            </div>

            {
                isLoading === true ?
                    loader() :
                    <>
                        <div className="flex flex-col items-center w-full flex-1 overflow-auto">
                            <div className="flex flex-col items-center w-full flex-1 overflow-auto">
                                <div className="flex items-center w-full py-4 px-4">
                                    <Stepper activeStep={passo_atual} alternativeLabel className="w-full">
                                        {steps.map((label) => (
                                            <Step key={label} sx={{
                                                '& .MuiStepLabel-root .Mui-completed': {
                                                    color: cores.cor3, // circle color (COMPLETED)
                                                },
                                                '& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel':
                                                {
                                                    color: cores.cor2, // Just text label (COMPLETED)
                                                },
                                                '& .MuiStepLabel-root .Mui-active': {
                                                    color: cores.cor1, // circle color (ACTIVE)
                                                },
                                                '& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel':
                                                {
                                                    color: cores.cor1, // Just text label (ACTIVE)
                                                },
                                                '& .MuiStepLabel-root .Mui-active .MuiStepIcon-text': {
                                                    fill: 'white', // circle's number (ACTIVE)
                                                },
                                            }}>
                                                <StepLabel>{label}</StepLabel>
                                            </Step>
                                        ))}
                                    </Stepper>

                                </div>

                                {
                                    passo_atual === 0 ?
                                        <div className="flex flex-col w-full p-6">


                                            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 w-full">
                                                {
                                                    lista_cadernos_ativos.length === 0 ? (
                                                        <div className="text-gray-400 py-4">Cadernos Não Encontrados</div>
                                                    ) : (
                                                        lista_cadernos_ativos.map((el, key) => {
                                                            const isSelected = obj_new?.id_rosto === el.id_rosto;
                                                            const isHovered = hover.flag && hover.id_rosto === el.id_rosto;
                                                            return (
                                                                <div
                                                                    key={key}
                                                                    className={`
                              flex flex-col items-center justify-center min-w-0 p-4 rounded-xl cursor-pointer
                              transition-all duration-200
                              ${isSelected ? 'ring-2 ring-[#c94f1e] bg-[#f2d1c2]/30' : 'bg-gray-50/80'}
                              ${isHovered ? 'shadow-md' : 'shadow-sm'}
                            `}
                                                                    onMouseEnter={() => setHover({ flag: true, id_rosto: el.id_rosto })}
                                                                    onMouseLeave={() => setHover({ flag: false, id_rosto: el.id_rosto })}
                                                                    onClick={() => {
                                                                        if (obj_new?.id_rosto === el.id_rosto) {
                                                                            set_obj_new((prev: any) => ({
                                                                                ...prev,
                                                                                id_rosto: undefined,
                                                                            }));

                                                                        } else {

                                                                            set_obj_new((prev: any) => ({
                                                                                ...prev,
                                                                                id_rosto: el.id_rosto,
                                                                            }));
                                                                        }

                                                                    }}
                                                                >
                                                                    <div className="text-sm font-medium text-gray-800 text-center">
                                                                        {el.cultura_caderno}
                                                                    </div>
                                                                    <div
                                                                        className={`mt-2 w-full h-1 rounded-full ${isSelected ? 'bg-[#c94f1e]' : 'bg-gray-200'}`}
                                                                    />
                                                                </div>
                                                            );
                                                        })
                                                    )
                                                }
                                            </div>

                                            <div className="flex justify-end w-full pt-4">

                                                <button
                                                    type="button"
                                                    onClick={() => {

                                                        if (obj_new?.id_rosto === undefined) {
                                                            setMessage("Selecione um caderno para avançar")
                                                            setOpenSnackError(true);
                                                        } else {
                                                            get_info_by_id_cara();
                                                            set_passo_atual(1);

                                                        }

                                                    }}
                                                    className="px-5 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                                >
                                                    Seguinte
                                                </button>
                                            </div>
                                        </div> :
                                        passo_atual === 1 ?
                                            <div className="flex flex-col w-full p-6 gap-6">


                                                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 w-full">
                                                    {
                                                        lista_caraterizacao.length === 0 ? (
                                                            <div className="text-gray-400 py-4">Áreas Sob Compromisso Não Encontrados</div>
                                                        ) : (
                                                            lista_caraterizacao.map((el, key) => {
                                                                const isSelected = obj_new?.id_cara === undefined || obj_new?.id_cara.length === 0 ? false : obj_new?.id_cara.find((elo) => {
                                                                    if (elo === el.id_cara) {
                                                                        return true
                                                                    }
                                                                })
                                                                const isHovered = hover1.find((elem) => {
                                                                    if (elem.id_cara === el.id_cara && elem.flag === true) {
                                                                        return true
                                                                    }

                                                                })
                                                                return (
                                                                    <div
                                                                        key={key}
                                                                        className={`
                              flex flex-col items-center justify-center min-w-0 p-4 rounded-xl cursor-pointer
                              transition-all duration-200
                              ${isSelected ? 'ring-2 ring-[#c94f1e] bg-[#f2d1c2]/30' : 'bg-gray-50/80'}
                              ${isHovered ? 'shadow-md' : 'shadow-sm'}
                            `}
                                                                        onMouseEnter={() => setHover1((old) => [...old, { flag: true, id_cara: el.id_cara ?? 0 }])}
                                                                        onMouseLeave={() => setHover1((old) => [...old, { flag: false, id_cara: el.id_cara ?? 0 }])}
                                                                        onClick={() => {
                                                                            const isSelected = obj_new?.id_cara === undefined || obj_new?.id_cara.length === 0 ? false : obj_new?.id_cara.find((elo) => {
                                                                                if (elo === el.id_cara) {
                                                                                    return true
                                                                                }
                                                                            })
                                                                            if (isSelected) {

                                                                                let aux_list = obj_new?.id_cara === undefined || obj_new?.id_cara.length === 0 ? [] : obj_new?.id_cara.filter((elo) => {
                                                                                    if (elo === el.id_cara) {
                                                                                        return false
                                                                                    } else {
                                                                                        return true
                                                                                    }
                                                                                })

                                                                                set_obj_new((prev: any) => ({
                                                                                    ...prev,
                                                                                    id_cara: aux_list,
                                                                                }));

                                                                            } else {
                                                                                let aux_list = obj_new?.id_cara ? [...obj_new.id_cara, el.id_cara] : [el.id_cara]

                                                                                set_obj_new((prev: any) => ({
                                                                                    ...prev,
                                                                                    id_cara: aux_list,
                                                                                }));
                                                                            }


                                                                        }}
                                                                    >
                                                                        <div className="text-sm font-medium text-gray-800 text-center">
                                                                            {el.parcela_numero} - {el.nome_parcela}
                                                                        </div>
                                                                        <div
                                                                            className={`mt-2 w-full h-1 rounded-full ${isSelected ? 'bg-[#c94f1e]' : 'bg-gray-200'}`}
                                                                        />
                                                                    </div>
                                                                );
                                                            })
                                                        )
                                                    }
                                                </div>

                                                <div className="flex justify-between w-full pt-4">
                                                    <button
                                                        type="button"
                                                        onClick={() => set_passo_atual(0)}
                                                        className="px-5 py-2.5 rounded-xl font-medium text-sm text-gray-600 bg-gray-100 hover:bg-gray-200 transition-colors border-0 outline-none cursor-pointer"
                                                    >
                                                        Voltar
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            if (obj_new?.id_cara === undefined) {
                                                                setMessage("Selecione uma área de compromisso para avançar")
                                                                setOpenSnackError(true);
                                                            } else {

                                                                set_passo_atual(2)
                                                            }
                                                        }}
                                                        className="px-5 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                                    >
                                                        Seguinte
                                                    </button>
                                                </div>
                                            </div> :
                                            passo_atual === 2 ?
                                                <div className="flex flex-col w-full p-6 ">
                                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full items-start">
                                                        <div className="w-full">
                                                            <CustomTextField
                                                                variant="outlined"
                                                                label='Designação'
                                                                name="nome"
                                                                value={obj_new?.nome === undefined ? '' : obj_new?.nome}
                                                                onChange={onInputChange}
                                                                error={campo_obrigatorio_nome}
                                                                helperText={campo_obrigatorio_nome ? 'Campo Obrigatório' : ""}
                                                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                            />
                                                        </div>
                                                        <div className="w-full">

                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DatePicker
                                                                    views={["year"]}
                                                                    label='Ano'
                                                                    value={
                                                                        obj_new?.ano === undefined || obj_new?.ano === null || obj_new?.ano === 0
                                                                            ? null
                                                                            : dayjs(String(obj_new?.ano), "YYYY")
                                                                    }
                                                                    onChange={(newValue) => {
                                                                        onInputChange({
                                                                            target: {
                                                                                name: "ano",
                                                                                value: newValue ? newValue.format("YYYY") : "",
                                                                            },
                                                                        });
                                                                        set_campo_invalido_ano(false)
                                                                    }}
                                                                    minDate={dayjs("2010")}
                                                                    slots={{
                                                                        textField: (textFieldProps) => (
                                                                            <TextField
                                                                                {...textFieldProps}
                                                                                fullWidth
                                                                                margin="normal"
                                                                                InputLabelProps={{ shrink: true }}
                                                                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                                                helperText={campo_invalido_ano ? 'Campo Obrigatório' : ""}
                                                                                error={campo_invalido_ano}
                                                                            />
                                                                        ),
                                                                    }}
                                                                />
                                                            </LocalizationProvider>

                                                        </div>
                                                        <div className="w-full">
                                                            <CustomTextField
                                                                variant="outlined"
                                                                label='Descrição'
                                                                name="descricao"
                                                                value={obj_new?.descricao === undefined ? '' : obj_new?.descricao}
                                                                onChange={onInputChange}
                                                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full items-start">
                                                        <div className="md:col-span-2 w-full">
                                                            <CustomTextField
                                                                variant="outlined"
                                                                label='Cultura'
                                                                name="cultura"
                                                                value={obj_new?.cultura === undefined ? '' : obj_new?.cultura}
                                                                onChange={onInputChange}
                                                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                            />
                                                        </div>
                                                        <div className="w-full">
                                                            <CustomTextField
                                                                variant="outlined"
                                                                label='Estado'
                                                                name="estado"
                                                                value={obj_new?.estado === undefined ? '' : obj_new?.estado}
                                                                onChange={onInputChange}
                                                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full items-start">
                                                        <div className="w-full">
                                                            <CustomTextField
                                                                variant="outlined"
                                                                label='Orçamento Total'
                                                                name="orcamento_total"
                                                                error={error_orcamento_total}
                                                                helperText={error_orcamento_total ? 'Insira um valor numérico' : ""}
                                                                value={obj_new?.orcamento_total === undefined ? '' : obj_new?.orcamento_total}
                                                                onChange={onInputChange}
                                                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                            />
                                                        </div>
                                                        <div className="w-full">
                                                            <CustomTextField
                                                                variant="outlined"
                                                                label='Alerta Percentagem'
                                                                name="alerta_percentagem"
                                                                error={error_alerta_percentagem}
                                                                helperText={error_alerta_percentagem ? 'Insira um valor numérico' : ""}
                                                                value={obj_new?.alerta_percentagem === undefined ? '' : obj_new?.alerta_percentagem}
                                                                onChange={onInputChange}
                                                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                            />
                                                        </div>
                                                        <div className="w-full">
                                                            <CustomTextField
                                                                variant="outlined"
                                                                label='Tipo de Entidade'
                                                                name="tipo_entidade"
                                                                value={obj_new?.tipo_entidade === undefined ? '' : obj_new?.tipo_entidade}
                                                                onChange={onInputChange}
                                                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="flex justify-between w-full pt-4">
                                                        <button
                                                            type="button"
                                                            onClick={() => set_passo_atual(1)}
                                                            className="px-5 py-2.5 rounded-xl font-medium text-sm text-gray-600 bg-gray-100 hover:bg-gray-200 transition-colors border-0 outline-none cursor-pointer"
                                                        >
                                                            Voltar
                                                        </button>
                                                        <button
                                                            type="button"
                                                            onClick={() => {


                                                                if (obj_new?.nome === undefined || obj_new.nome === '') {
                                                                    set_campo_obrigatorio_nome(true);
                                                                } else if (obj_new?.ano === undefined || obj_new.ano === null) {
                                                                    set_campo_invalido_ano(true);
                                                                } else if (error_alerta_percentagem === true) {
                                                                    set_error_alerta_percentagem(true);
                                                                } else if (error_orcamento_total === true) {
                                                                    set_error_orcamento_total(true);
                                                                } else {
                                                                    set_campo_obrigatorio_nome(false);
                                                                    set_campo_invalido_ano(false);
                                                                    set_error_alerta_percentagem(false);
                                                                    set_error_orcamento_total(false);

                                                                    if (flag_open_modal_edit === true && flag_open_modal_add === false) {
                                                                        handler_edit();
                                                                    } else if (flag_open_modal_add === true) {
                                                                        handler_add();
                                                                    }
                                                                }
                                                            }}
                                                            className="px-5 py-2.5 mt-4 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                                        >
                                                            {
                                                                flag_open_modal_edit === true ? 'Guardar Alterações' : 'Adicionar Plano ERP'
                                                            }
                                                        </button>
                                                    </div>
                                                </div>
                                                :
                                                null
                                }



                            </div>



                        </div>
                    </>
            }
            <ConfirmDialog
                open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                onConfirm={() => handleCloseDialog()}
                message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
        </div>



    </Modal>)

}
